if (process.env.NODE_ENV === 'production') {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const { hostname, protocol, pathname, search, port } = window.location;

  if (isMobile && hostname.startsWith('www.')) {
    const newHostname = hostname.replace('www.', 'mobile.');
    const portString = port ? `:${port}` : '';
    window.location.href = `${protocol}//${newHostname}${portString}${pathname}${search}`;
  } else if (!isMobile && hostname.startsWith('mobile.')) {
    const newHostname = hostname.replace('mobile.', 'www.');
    const portString = port ? `:${port}` : '';
    window.location.href = `${protocol}//${newHostname}${portString}${pathname}${search}`;
  }
}

import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@vant/touch-emulator';
import FastClick from 'fastclick'
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import zhTW from 'vant/es/locale/lang/zh-TW';
import { Locale } from 'vant';
import { applyVantLocale } from './utils/vantLocale'
import { getRemark, getUser, getUserId } from './utils/auth'
import { getDefaultLanguage } from './utils/common';
import { isQiabotNewType, openQiabotWidget } from './utils/qiabot'

// 设置vant组件库的语言
const currentLocale = localStorage.getItem('locale') || getDefaultLanguage();
applyVantLocale(currentLocale, Locale, enUS, zhTW)


Vue.config.productionTip = false
Vue.config.ignoredElements = [/^altcha-/]

import './assets/css/common.less';
import './assets/fonts/iconfont.css';
import 'lib-flexible/flexible'

import i18n from './i18n/index'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Initialize device fingerprint collection
import deviceFingerprint from './utils/deviceFingerprint'
Vue.prototype.$deviceFingerprint = deviceFingerprint

// Initialize device fingerprint on app startup
deviceFingerprint.init().catch(error => {
  console.error('Failed to initialize device fingerprint:', error)
})

Vue.prototype.i18n = i18n

// 顶部title是否隐藏
Vue.prototype.hideTopBar = false

//货币单位
let localCurrency = localStorage.getItem('localCurrency') || 'USDT'
Vue.prototype.localCurrency = localCurrency

// 客服函数
const ChatWoot = function () {
    console.log("ChatWoot")
    let Remark = getRemark()
    let username = getUser()
    console.log(username)
    console.log(Remark)
    if(username !== null) {
        let obj = {
            name:"账号："+ username + " 备注：" + Remark,
            email: "",
            Remark: Remark,
        }
        window.$chatwoot.setUser(username, obj);
    }
    window.$chatwoot.toggle('open');
}

const meiqia = function() {
    _MEIQIA('withoutBtn');
    _MEIQIA('showPanel');
    _MEIQIA('language','en')
    // 传递顾客信息
    _MEIQIA('metadata', {
        ID: getUserId(), // 美洽默认字段
        name: getUser(), // 美洽默认字段
        username: getUser(), // 美洽默认字段
    });
}

// 定义全局客服函数
Vue.prototype.$kefu = function() {
    let Type = window.localStorage.getItem('kefuType')
    if (isQiabotNewType(Type)) {
        openQiabotWidget()
        return
    }
    switch (Type) {
        case 'meiqia':
            console.log("meiqia")
            meiqia()
            break
        case 'chatwoot':
            ChatWoot()
            break
    }
};

FastClick.prototype.focus = function(targetElement) {
  var length;
  var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;
  var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;
  //兼容处理:在iOS7中，有一些元素（如date、datetime、month等）在setSelectionRange会出现TypeError
  //这是因为这些元素并没有selectionStart和selectionEnd的整型数字属性，所以一旦引用就会报错，因此排除这些属性才使用setSelectionRange方法
  if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month' && targetElement.type !== 'email') {
    length = targetElement.value.length;
    targetElement.setSelectionRange(length, length); //修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘
    targetElement.focus();
  } else {
    targetElement.focus();
  }
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
